import React from "react";
import InfoSection from "./InfoSection";
import EditableInfoRow from "./EditableInfoRow";

const AboutSection = ({ data, isEditing, isLoading, onEdit, onSave, onCancel, onChange }) => {
    const about = data || {};

    return (
        <InfoSection
            title="About"
            icon="solar:info-circle-bold"
            isEditing={isEditing}
            isLoading={isLoading}
            onEdit={onEdit}
            onSave={onSave}
            onCancel={onCancel}
        >
            <div className="row">
                <EditableInfoRow
                    label="Description"
                    value={about.description}
                    icon="solar:document-text-bold-duotone"
                    colSize="col-md-12"
                    isEditing={isEditing}
                    fieldKey="description"
                    onChange={onChange}
                    type="textarea"
                    maxLength={250}
                />
            </div>
        </InfoSection>
    );
};

export default AboutSection;
